import { useState } from "react"
import data from '../../data.json'
import "./Body.css"
import FilterBar from "./FilterBar"
import Job from './Job'
console.log(data)
const Body = ()=>{
   const [options,setOptions] = useState([])
   function show(stacks){
    for (let i =0;i<options.length;i++)
        if (!stacks.includes(options[i])) return false

    return true
   }
    return(
        <div className="body">
            <div className="container">
                <div className="wrapper">
                    { options.length>0 && <FilterBar options={options} setOptions={setOptions}/>}
                </div>
                <div className="jobs">
                    {
                     data.map(el=> show([...el.languages,...el.tools,el.level,el.role]) && <Job job={el} key={el.id} options={options} setOptions={setOptions}/>)
                    }
                </div>
            </div>
        </div>
    )
}
export default Body